module.exports = __webpack_public_path__ + "static/media/Rec4.1078fb83.png";